import { render, staticRenderFns } from "./UploadFileCsv.vue?vue&type=template&id=384b6e0e&scoped=true&"
import script from "./UploadFileCsv.vue?vue&type=script&lang=js&"
export * from "./UploadFileCsv.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileCsv.vue?vue&type=style&index=0&id=384b6e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b6e0e",
  null
  
)

export default component.exports